/* eslint-disable no-unused-vars */
import React from "react";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  TableContainer,
  Button,
  Grid,
  // MenuItem,
  Divider,
  // Autocomplete,
  // TextField,
} from "@mui/material";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import PageContainer from "src/components/container/PageContainer";
import ParentCard from "src/components/shared/ParentCard";
import { useState, useEffect } from "react";
// import moment from "moment";
// import CustomSelect from "src/components/forms/theme-elements/CustomSelect";
// import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";

import ReportService from "src/service/reports";
import * as XLSX from "xlsx";

// import CustomTextField from "src/components/forms/theme-elements/CustomTextField";
import { IconFileDownload } from "@tabler/icons";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: "Device Installation Report",
  },
];

const DeviceInstallationReport = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const [deviceInstallation, setdeviceInstallation] = useState([]);
  // const [device_name, setDevice_name] = useState([]);
  // const [selectedDevice, setSelectedDevice] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  // const handleDeviceChange = (event) => {
  //   setSelectedDevice(event.target.value);
  // };

  // const filteredData = deviceInstallation.filter((item) => {
  //   if (!selectedDevice || item.imei_no === selectedDevice) {
  //     return true;
  //   }
  //   return false;
  // });

  const handleFromDateChange = (event) => {
    setFromDate(event.target.value);
  };

  const handleToDateChange = (event) => {
    setToDate(event.target.value);
  };

  const filteredData = deviceInstallation.filter((item) => {
    const installationDate = item.installation_datetime;
    const fromDateValid = !fromDate || installationDate;
    const toDateValid = !toDate || installationDate;
    // const deviceValid = !selectedDevice || item.imei_no === selectedDevice;

    return fromDateValid && toDateValid;
  });

  // const fetchDeviceData = async () => {
  //   try {
  //     const res = await ReportService.getDevicelistforInstallation({
  //       // manufacturer_id: sessionData.data.id,
  //
  //     });

  //     setDevice_name(res.data);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const fetchDeviceInstallationData = async () => {
    try {
      const res = await ReportService.getDeviceInstallationReport({
        manuafacturer_id: sessionData.data.manufacturer_id,
        distributor_id: sessionData.data.distributor_id,
      });
      setdeviceInstallation(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchDeviceInstallationData();

    // fetchDeviceData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionData.data.id, sessionData.data.user_type]);

  // ============== export in excel start ===========================
  const exportVisibleDataToExcel = () => {
    const table = document.getElementById("allotment_report_table");
    if (!table) {
      alert("Table not found");
      return;
    }

    const rows = [];

    for (let i = 0; i < table.rows.length; i++) {
      const row = [];
      const currentRow = table.rows[i];

      for (let j = 0; j < currentRow.cells.length; j++) {
        const cell = currentRow.cells[j];
        row.push(cell.textContent);
      }

      rows.push(row);
    }

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(rows);

    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    const wbout = XLSX.write(wb, { type: "binary", bookType: "xlsx" });

    const fileName = "Distributor To Agency Allotment Report.xlsx";
    const dataBlob = new Blob([s2ab(wbout)], {
      type: "application/octet-stream",
    });

    if (window.navigator.msSaveBlob) {
      window.navigator.msSaveOrOpenBlob(dataBlob, fileName);
    } else {
      const url = window.URL.createObjectURL(dataBlob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const s2ab = (s) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i += 1) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  };
  // ============== export in excel ends ============================
  return (
    <PageContainer
      title="Device Installation"
      description="this is Basic Table page"
    >
      <Breadcrumb title="Device Installation Report" items={BCrumb} />

      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Device Installation Report
            </Typography>
          </Grid>
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="success"
              onClick={exportVisibleDataToExcel}
            >
              <IconFileDownload width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />
        <Grid container alignItems="center" style={{ marginTop: "10px" }}>
          <Grid
            item
            container
            xs={12}
            style={{ paddingBottom: "20px" }}
            alignItems="center"
            spacing={2}
          >
            {/* <Grid item lg={4} md={6} sm={6} xs={12}>
              <CustomFormLabel>From Date</CustomFormLabel>
              <CustomTextField
                type="date"
                id="from_date"
                name="from_date"
                fullWidth
                value={fromDate}
                onChange={handleFromDateChange}
              />
            </Grid> */}
            {/* <Grid item lg={4} md={6} sm={6} xs={12}>
              <CustomFormLabel>To Date</CustomFormLabel>
              <CustomTextField
                type="date"
                id="to_date"
                name="to_date"
                fullWidth
                value={toDate}
                onChange={handleToDateChange}
              />
            </Grid> */}
          </Grid>
        </Grid>
        <Paper variant="outlined">
          <TableContainer>
            <Table
              id="allotment_report_table"
              aria-label="simple table"
              sx={{
                whiteSpace: "nowrap",
              }}
            >
              <TableHead style={{ backgroundColor: "silver" }}>
                <TableRow>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Sl. No
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Agency Or User Name
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      User Type
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Device Name
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Imei No
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Vehicle Name
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      No of Wheels
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Vehicle No
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Make
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Model
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Installation
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {filteredData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={12}>
                      <Typography
                        style={{
                          fontSize: "14px",
                          textAlign: "center",
                          color: "red",
                        }}
                        variant="h6"
                      >
                        No records found
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredData.map((item, index) => (
                    <TableRow key={item.id}>
                      <TableCell>
                        <Typography
                          style={{ fontSize: "13px", textAlign: "center" }}
                          variant="h6"
                        >
                          {index + 1}
                        </Typography>
                      </TableCell>

                      <TableCell>
                        <Typography
                          style={{ fontSize: "13px", textAlign: "center" }}
                          variant="h6"
                        >
                          {item.agency_or_indivisual_user_name !== null
                            ? item.agency_or_indivisual_user_name
                            : "NA"}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          style={{ fontSize: "13px", textAlign: "center" }}
                          variant="h6"
                        >
                          {item.user_type === 4
                            ? "Agency"
                            : item.user_type === 5
                            ? "Indivisual User"
                            : "NA"}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          style={{ fontSize: "13px", textAlign: "center" }}
                          variant="h6"
                        >
                          {item.device_name !== null ? item.device_name : "NA"}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          style={{ fontSize: "13px", textAlign: "center" }}
                          variant="h6"
                        >
                          {item.imei_no !== null ? item.imei_no : "NA"}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          style={{ fontSize: "13px", textAlign: "center" }}
                          variant="h6"
                        >
                          {item.vehicle_name !== null
                            ? item.vehicle_name
                            : "NA"}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          style={{ fontSize: "13px", textAlign: "center" }}
                          variant="h6"
                        >
                          {item.wheel_type !== null ? item.wheel_type : "NA"}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          style={{ fontSize: "13px", textAlign: "center" }}
                          variant="h6"
                        >
                          {item.vehicle_no !== null ? item.vehicle_no : "NA"}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          style={{ fontSize: "13px", textAlign: "center" }}
                          variant="h6"
                        >
                          {item.make !== null ? item.make : "NA"}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          style={{ fontSize: "13px", textAlign: "center" }}
                          variant="h6"
                        >
                          {item.model !== null ? item.model : "NA"}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography style={{ fontSize: "14px" }} variant="h6">
                          {item.installation_datetime !== null
                            ? item.installation_datetime
                            : "NA"}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </ParentCard>
    </PageContainer>
  );
};

export default DeviceInstallationReport;
